import React, { useEffect } from "react";
import { StyleSheet, View, ScrollView } from "react-native";
import { colors } from "src/assets";
import { FormControlGroup, FormControlLabel, Typography } from "src/components";
import { useNavigation } from "@react-navigation/native";
import { useCognito } from "src/hooks";
import LocalText from "src/local";
import { RootStackScreenProps } from "src/navigation/types";

export const MyAccountScreen: React.FC = () => {
  const navigation =
    useNavigation<RootStackScreenProps<"MyAccount">["navigation"]>();
  const [, cognitoAttributes] = useCognito();

  return (
    <View style={styles.container}>
      <ScrollView>
        <FormControlGroup style={styles.section}>
          <Typography
            text={LocalText.screens.myAccount.email}
            variant={"section"}
          />
          <FormControlLabel
            text={cognitoAttributes.email}
            rightIcon={"chevron"}
            onPress={() => navigation.push("MyAccountEmail")}
          />
          <Typography
            text={LocalText.screens.myAccount.emailDescription}
            variant={"section"}
          />
          <Typography
            text={LocalText.screens.myAccount.password}
            variant={"section"}
          />
          <FormControlLabel
            text={"●●●●●●●●●"}
            rightIcon={"chevron"}
            onPress={() => navigation.push("MyAccountPassword")}
          />
        </FormControlGroup>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  section: {
    marginTop: 8,
  },
  container: {
    flex: 1,
    backgroundColor: colors.gray1,
  },
});
